<template>
  <div class="full-height">
    <AppHeader />
    <section class="body-top">
      <div class="container">
        <div class="columns">
          <div class="column">
            <h1 class="title is-4">Call Details</h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li>
                  <router-link :to="{ name: 'Home' }">
                    <span class="icon is-small">
                      <i class="fas fa-home" aria-hidden="true"></i>
                    </span>
                    <span>Home</span>
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      name: 'Billing-report',
                      params: {
                        accountId: accountId,
                        search_date: selectedYear && selectedMonth ? selectedYear +'-'+selectedMonth : undefined
                      }
                    }"
                  >
                    <span class="icon is-small">
                      <i class="fas fa-file-invoice" aria-hidden="true"></i>
                    </span>
                    <span>Monthly Report</span>
                  </router-link>
                </li>
                <li class="is-active">
                  <a href="#" aria-current="page">
                    <span class="icon is-small">
                      <i class="fas fa-list" aria-hidden="true"></i>
                    </span>
                    <span>Call history</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="column">
            <div class="field has-addons has-addons-right">
              <p class="control">
                <span class="select">
                  <select name="month" v-model="selectedMonth" @change="getMonthlyReport()">
                    <!-- <option value="null" selected>--Month--</option> -->
                    <option value="01">Janaury</option>
                    <option value="02">February</option>
                    <option value="03">March</option>
                    <option value="04">April</option>
                    <option value="05">May</option>
                    <option value="06">June</option>
                    <option value="07">July</option>
                    <option value="08">August</option>
                    <option value="09">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </span>
              </p>
              <p class="control">
                <span class="select">
                  <select name="year" v-model="selectedYear" @change="getMonthlyReport()">
                    <option v-for="year in years" :key="year" :value="year">
                      {{
                      year
                      }}
                    </option>
                    <!-- <option value="null" selected>--Year--</option> -->
                  </select>
                </span>
              </p>
              <p class="control" v-if="$cnc.actor.role == 'admin'">
                <input
                  class="input"
                  type="text"
                  id="accountId"
                  placeholder="Account ID"
                  autocomplete="off"
                  :value="this.accountId || ''"
                  @change="getMonthlyReport()"
                />
              </p>
              <p class="control">
                <a class="button is-primary" @click="downloadCSV">Export</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="columns">
          <div class="column">
            <h1 class="title is-5">
              {{
              accountDetails.company
              ? accountDetails.company + " (" + accountId + "),"
              : ""
              }}
              {{ normNumber ? "DID - " + normNumber + "," : "" }}
              Month - {{ `${selectedYear}-${selectedMonth}` }}
            </h1>
            <cnc-table
              ref="downloadAble"
              schema="Calls"
              :columns="showColumns"
              :columnLabels="{
                normNumber: 'DID',
                fromId: 'Origin From',
                displayName: 'Display Name'
              }"
              :extraFields="['accountId', 'month']"
              :filters="{
                month:
                  selectedYear && selectedMonth
                    ? selectedYear.toString() + '-' + selectedMonth.toString()
                    : undefined,
                accountId: accountId,
                normNumber: normNumber
              }"
              :defaultSort="[{ path: 'date', direction: 'ASCENDING' }]"
              :limit="100"
            />
            <table class="table is-fullwidth invoice-total" v-if="models && models.length">
              <tbody>
                <tr>
                  <td>
                    <strong>Total Minutes:</strong>
                  </td>
                  <td>{{ totalMinutes }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total Cost:</strong>
                  </td>
                  <td>${{ roundNumber(totalCost) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    <AppFooter />
  </div>
</template>

<script>
import prop from "propper";
import autocomplete from "autocompleter";
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";

export default {
  name: "home",
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      showColumns: [
        "date",
        "normNumber",
        "fromId",
        "displayName",
        "duration",
        "minutes",
        "cost"
      ],
      models: null,
      accountId: this.$route.params.account_id,
      accountDetails: [],
      selectedYear: prop(this.$route, ["params", "search_date"])
        ? this.$route.params.search_date.split("-")[0]
        : undefined,
      selectedMonth: prop(this.$route, ["params", "search_date"])
        ? this.$route.params.search_date.split("-")[1]
        : undefined,
      normNumber: this.$route.params.norm_number
    };
  },
  computed: {
    years() {
      let years = [];
      let d = new Date();
      years.push(d.getFullYear());
      do {
        d.setFullYear(d.getFullYear() - 1);
        years.push(d.getFullYear());
      } while (d.getFullYear() !== 2014);
      return years;
    },
    totalMinutes() {
      if (!this.models) {
        return 0;
      }
      const total = this.models.reduce((prev, next) => prev + next.minutes, 0);
      return total;
    },
    totalCost() {
      const total = this.models.reduce((prev, next) => prev + next.cost, 0);
      return total;
    }
  },
  methods: {
    roundNumber(number) {
      return number.toFixed(2);
    },
    async getBillingAccounts() {
      const result = await this.$cnc.load({
        query: `query {
          models: BillingAccountsMany(options:{sort:[{path:"name", direction: ASCENDING}]}) {
            label: name
            value: accountId
          }
        }`
      });

      if (result) {
        this.accounts = result.models.map(({ label, value }) => ({
          label: value + " - " + label,
          value
        }));
      }

      var input = document.getElementById("accountId");
      if (input) {
        this.setAutoComplete(input);
      }
    },
    setAutoComplete(input) {
      var accounts = this.accounts;
      autocomplete({
        minLength: 1,
        input: input,
        emptyMsg: "No account found",

        fetch: function(text, update) {
          text = text.toLowerCase();
          var suggestions = accounts.filter(n =>
            n.label.toLowerCase().includes(text)
          );
          update(suggestions);
        },
        onSelect: item => {
          input.value = item.value;
          this.accountId = item.value;
        }
      });
    },
    async getMonthlyReport() {
      if (!this.selectedYear || !this.selectedMonth || !this.accountId) {
        return;
      }

      const result = await this.$cnc.load({
        query: `query ($month:String!, $accountId:ID!, $normNumber:String) {
            models:CallsMany(condition: {month:$month, accountId:$accountId, normNumber:$normNumber}) {
              minutes
              cost
            }
            accountDetails:AccountOne(id: $accountId) {
              company
            }
          }`,
        vars: {
          month: `${this.selectedYear}-${this.selectedMonth}`,
          accountId: this.accountId,
          normNumber: this.normNumber
        }
      });

      this.models = result.models;
      this.accountDetails = result.accountDetails;
    },
    async downloadCSV() {
      this.$refs.downloadAble.downloadCSV(
        `call-history-${this.accountId}-${this.selectedYear}-${this.selectedMonth}.csv`
      );
    }
  },
  mounted() {
    this.getBillingAccounts();

    window.table = this;

    this.accountId = this.accountId || this.$cnc.actor.id || null;

    var today = new Date();
    today.setDate(0); // 0 will result in the last day of the previous month
    // console.log(today.toDateString());
    this.selectedMonth =
      this.selectedMonth || (today.getMonth() + 1).toString().padStart(2, "0");
    this.selectedYear = this.selectedYear || today.getFullYear();

    this.getMonthlyReport();
  }
};
</script>

<style scoped>
.full-height {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  min-height: calc(100vh - 52px);
  overflow: hidden;
}

.body-top {
  position: relative;
  margin-bottom: 1.5rem;
}
.body-top .title:not(:last-child) {
  margin-bottom: 0.5rem;
}

/* INVOICE */
.invoice-table tbody > tr > td,
.invoice-total > tbody > tr > td:first-child {
  text-align: right;
}

.invoice-total > tbody > tr > td {
  border: 0 none;
}
.invoice-total > tbody > tr > td:last-child {
  border-bottom: 1px solid #dddddd;
  text-align: center;
  width: 20%;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
